module.exports = __webpack_public_path__ + "static/media/img4.eaac9c6a.jpg";